const DEFAULT_DIGITS = 2;
const DEFAULT_LOCALE = "pl-PL";
const DEFAULT_CURRENCY = "PLN";

export const formatPrice = (
  amount: string | number,
  currency: string = DEFAULT_CURRENCY,
  locale: string = DEFAULT_LOCALE,
  digits: number = DEFAULT_DIGITS,
) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: digits,
  }).format(typeof amount === "number" ? amount : parseFloat(amount));
};
